import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import EvaluationSubmissionGraph from 'conversations/evaluation-submission/EvaluationSubmissionGraph';

export default function FinalScore(props: {
	name: string;
	item: graphql.EvaluationFinalScoreItem;
	score?: number;
	readonly?: boolean;
}) {
	const { localize } = useLocalize();

	const exampleScores = [0.1, 0.4, 0.9, 0.3, 0.7];

	return (
		<>
			<ParagraphSmall color="slateBlue" style={{ maxWidth: 600 }}>
				{localize(props.item.title ?? [])?.text ?? 'Summary'}
			</ParagraphSmall>
			<EvaluationSubmissionGraph
				levels={(props.item.displayLevelSet ?? props.item.competencyLevelSet)!.levels.map(
					(level) => localize(level.title).text,
				)}
				sections={exampleScores.map((score, index) => ({
					name: `§ ${index + 1}`,
					score,
				}))}
			/>
		</>
	);
}
